export const PROTECTED_EARNINGS_RATE = 486630;

export default function rechner2026(wages, people) {
  let start = 159000;
  let addon = 0;
  let index = -1;

  if (wages < 9999) {
    wages *= 100;
  }

  if (people === 1) {
    start = 219000;
  }
  if (people === 2) {
    start = 252000;
  }
  if (people === 3) {
    start = 286000;
  }
  if (people === 4) {
    start = 319000;
  }
  if (people === 5) {
    start = 352000;
  }

  if (wages > PROTECTED_EARNINGS_RATE) {
    addon = wages - PROTECTED_EARNINGS_RATE;
    wages = PROTECTED_EARNINGS_RATE;
  }

  while (wages >= start) {
    start += 1000;
    index++;
  }

  if (index === -1) {
    return 0;
  }

  let startAmount = 182;
  let indexAmount = 700;

  if (people === 1) {
    startAmount = 259;
    indexAmount = 500;
  }
  if (people === 2) {
    startAmount = 94;
    indexAmount = 400;
  }
  if (people === 3) {
    startAmount = 286;
    indexAmount = 300;
  }
  if (people === 4) {
    startAmount = 134;
    indexAmount = 200;
  }
  if (people === 5) {
    startAmount = 39;
    indexAmount = 100;
  }

  return startAmount + index * indexAmount + addon;
}
